import React, {FC} from "react"

import Button from "@irati/ui/src/Button"
import FormattedMessage from "@irati/utils/lang"
import {ValidationButton} from "@irati/ui/src/FormItem"
import tracking from "@irati-tracking/homepage/cultureHub"

import {StyledFooter} from "../../Modal/styled"
import {useCultureHubStore} from "../../../stores/hooks"

interface Props {
  onSubmit: () => void
}

const CompanyNewsContentFooter: FC<Props> = ({onSubmit}) => {
  const {state, dispatch} = useCultureHubStore()

  const handlePreviewClick = () => {
    tracking.clickCultureHubCta("culturehub", "Preview")
    dispatch({type: "SET_PREVIEW"})
  }

  if (state.isPreview) {
    return (
      <StyledFooter>
        <Button
          onClick={() =>
            dispatch({
              type: "SET_PREVIEW"
            })
          }>
          <FormattedMessage id="platform.homepage.companyNews.newContent.closePreview" />
        </Button>
      </StyledFooter>
    )
  }

  return (
    <StyledFooter>
      <ValidationButton onClick={handlePreviewClick} marginRight={1}>
        <FormattedMessage id="platform.homepage.companyNews.newContent.preview" />
      </ValidationButton>

      <ValidationButton primary onClick={onSubmit}>
        {state.isNotificationChecked ? (
          <FormattedMessage id="platform.homepage.companyNews.newContent.saveAndNotify" />
        ) : (
          <FormattedMessage id="platform.homepage.companyNews.newContent.save" />
        )}
      </ValidationButton>
    </StyledFooter>
  )
}

export default CompanyNewsContentFooter
